//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/SelectTaggedObject.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/SelectObject.js";
let d=[[[0,"ArrowLength",1,0],[0,"ArrowheadAngle",1,0],[0,"ArrowheadLength",1,0],[0,"BendAndEndSegmentWidthFactor",1,0],[0,"BorderToArrowDistance",1,0],[0,"Display",1,0],[0,"DisplayLettersOnBends",1,0],[0,"DisplayRotationLetter",1,0],[0,"Gap",1,0],[0,"LabelLocation",1,0],[1,"LineColorFontWidth",0,"LineColorFontWidthBuilder",0],[0,"LineLength",1,0],[0,"Overhang",1,0],[1,"SelectRotationLetter",0,"SelectTaggedObject",0],[0,"ShowSectionLine",1,0],[0,"Style",1,0],[0,"TypeStandard",1,0],[0,"UseLineLength",1,0],[0,"UseOffset",1,0]],[[["selectedObject"],"InheritSettingsFromSelectedObjects",{},1,0],[[],"InheritSettingsFromCustomerDefault",{},0,0],[[],"InheritSettingsFromPreferences",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.ViewSectionLineBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ViewSectionLineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ViewSectionLineBuilder.ShowSectionLineType = Object.freeze({
    "WithSectionView" : "WithSectionView", "WithoutSectionView" : "WithoutSectionView"});

SPLM.Drawings.ViewSectionLineBuilder.DisplayType = Object.freeze({
    "ArrowsAwayfromLine" : "ArrowsAwayfromLine", "ArrowstowardsLine" : "ArrowstowardsLine", "ThickEndsArrowstowardsLine" : "ThickEndsArrowstowardsLine", "ThickEndsArrowsAwayfromLine" : "ThickEndsArrowsAwayfromLine"});

SPLM.Drawings.ViewSectionLineBuilder.StyleType = Object.freeze({
    "Open" : "Open", "Closed" : "Closed", "Filled" : "Filled"});

SPLM.Drawings.ViewSectionLineBuilder.LocationType = Object.freeze({
    "OnArrow" : "OnArrow", "OnEnd" : "OnEnd"});

export default SPLM;